(function ()
{
  var myVar = setInterval(timer, 100);
  function timer()
  {
    if (window.jQuery)
    {
      $(document).ready(function ()
      {
       SwellConfig.LocalStorage.initializeLocalStorage();
      });
      stop();
    }
  }
  function stop()
  {
    clearInterval(myVar);
  }
}).call(this);
(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && (window.location.pathname === '/account' || window.location.pathname === '/')) {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);
